import { render, staticRenderFns } from "./ExperteList.vue?vue&type=template&id=046e795b&scoped=true&"
import script from "./ExperteList.vue?vue&type=script&lang=js&"
export * from "./ExperteList.vue?vue&type=script&lang=js&"
import style0 from "./ExperteList.vue?vue&type=style&index=0&id=046e795b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046e795b",
  null
  
)

export default component.exports